<lex-action-panel panelHeight="full" includeFooter="true" class="fontify-13px">
  <div action-title>
    <span *ngIf="!(selectedFact && selectedLinkedDocument)" >Facts and Issues</span>
    <span *ngIf="selectedFact && selectedLinkedDocument"> Edit Fact: {{selectedFact.title}}</span>
  </div>
  <div action-body style="overflow:auto; height: 100%;">
    <div *ngIf="!(selectedFact && selectedLinkedDocument)" style="padding: 8px 12px; height: calc(100% - 132px);
    overflow: auto;" >

      <div style="display: flex; flex-direction: row; justify-content: space-between; align-items: center; margin-bottom:12px;">
        <div style="display: flex; flex-direction: row; justify-content: flex-start; align-items: center; gap: 6px;">
          <label>Order Facts By </label>
          <mat-button-toggle-group appearance="legacy" (change)="sortDocFacts($event)" aria-label="Order Facts By: " [value]="sortBy" >
            <mat-button-toggle [value]="'1'" class="fontify-color">Start Date</mat-button-toggle>
            <mat-button-toggle [value]="'2'" class="fontify-color">Page</mat-button-toggle>
          </mat-button-toggle-group>
        </div>
        <div [matMenuTriggerFor]="addDocsToFact" matTooltip="Add Doc to Existing Fact" style="cursor: pointer;">
          <i class="fa-duotone fa-plus single-color-icon" style="font-size:18px;"></i>
        </div>
      </div>
      <mat-menu #addDocsToFact="matMenu" class="doc-viewer-menu">
        <menu mat-menu-item *ngFor="let caseFact of factsNotInDoc" (click)="addDocToFactAndSelect(caseFact)">
          {{caseFact.title}}
        </menu>
      </mat-menu>

      <ng-container *ngFor="let docFact of docFacts">
        <mat-card appearance="outlined" *ngIf="getFact(docFact.factId); let fact"  class="doc-fact" style="margin-top: 16px;">
          <mat-card-content>
            <div style="display: flex; flex-direction: column; gap: 4px;">
              <div style="display: flex; flex-direction: column; gap: 4px;">
                <div style="display: flex; flex-direction: row; justify-content: space-between;">
                  <div style="text-overflow: ellipsis; overflow: hidden; width: 100%; font-weight: 500;">
                    {{fact.title}}
                  </div>
                  <div style="display: flex; flex-direction: row;">
                    <div style="cursor: pointer;" (click)="editClicked(docFact)" matTooltip="Edit"><i class="fa-duotone fa-pen-to-square icon"></i></div>
                    <div style="margin-left:6px; cursor: pointer;" (click)="deleteFact(fact)" matTooltip="Delete"><i class="fa-duotone fa-trash-can icon"></i></div>
                  </div>
                </div>
                <div style="display: flex; flex-direction: row; justify-content: space-between;">
                  <div>
                    Start: {{fact.dateStart | date: 'M/d/y'}} - End: {{fact.dateEnd | date: 'M/d/y'}}
                  </div>
                  <div (click)="removeDocFact(docFact)" style="cursor: pointer;" matTooltip="Remove"><i
                      class="fa-duotone fa-xmark single-color-icon"></i>
                  </div>
                </div>
              </div>
              <div *ngIf="(currentDocumentSnapshot.bates.batesNumberStart + docFact.pageNumber - 1) > 0"
                style="display: flex; flex-direction: row; justify-content: flex-start; gap:8px;">
                <div>
                  <span>{{currentDocumentSnapshot.bates.batesPrefix}} {{(currentDocumentSnapshot.bates.batesNumberStart + docFact.pageNumber - 1).toString().padStart(currentDocumentSnapshot.bates.batesNumberDigits, '0')}}</span>
                </div>
                <div *ngIf="docFact.pageNumber > 0">
                  <span>(p: {{docFact.pageNumber}})</span>
                  <span (click)="viewPage(docFact.pageNumber)" style="margin-left:6px; cursor: pointer;" matTooltip="View"><i class="fa-duotone fa-arrow-up-from-bracket icon"></i></span>
                </div>
              </div>
            </div>
          </mat-card-content>
        </mat-card>
      </ng-container>
    </div>
    <!-- Edit Fact  -->
    <div *ngIf="selectedFact && selectedLinkedDocument" style="padding: 10px 20px 0 10px;">
      <div [formGroup]="editFactForm" style="display: flex; flex-direction: column; gap: 20px;">
        <div style="display: flex; flex-direction: row; justify-content: space-between; column-gap: 6px;">
          <div class="form-group" style="flex-grow: 2;">
            <lex-text-input label="Title" placeholder="Enter title" [formControl]="editFactForm.get('title')"></lex-text-input>
            <mat-error *ngIf="editFactForm.invalid">
              <ng-container *ngIf="editFactForm.get('title').hasError('maxlength')">
                Title must be at most 1024 characters long.
              </ng-container>
            </mat-error>
          </div>
          <div class="form-group">
            <lex-text-input label="Page" placeholder="Page" [formControl]="editFactForm.get('pageNumber')"></lex-text-input>
            <mat-error *ngIf="editFactForm.invalid">
              <ng-container *ngIf="(editFactForm.get('pageNumber')?.hasError('max')||editFactForm.get('pageNumber')?.hasError('min'))">
                Page number is invalid.
              </ng-container>
            </mat-error>
          </div>
        </div>
        <div style="display: flex; flex-direction: row; justify-content: space-between; column-gap: 14px;">
          <div class="form-group">
            <div class="form-container" style="margin-right:2px;">
              <label for="contest">Contested</label>
              <mat-select  matNativeControl id="contest-new-doc-viewer" style="height: 28px; border: 1px solid #565656;
              border-radius: 5px; display: flex; align-items: center; padding-left: 8px;" [(value)]="selectedFact.contested">
                <mat-option *ngFor="let contest of contestedList" [value]="contest.value">{{contest.displayValue}}</mat-option>
              </mat-select>
            </div>
          </div>
          <div class="form-group">
            <div class="form-container" style="margin-right: 8px;">
              <label for="material">Material</label>
              <mat-select matNativeControl style="height: 28px; border: 1px solid #565656;
              border-radius: 5px; display: flex; align-items: center; padding-left: 8px;"  [(value)]="selectedFact.material" id="material-new-doc-viewer">
                <mat-option [value]="0"></mat-option>
                <mat-option [value]="1">No</mat-option>
                <mat-option [value]="2">Yes</mat-option>
                <mat-option [value]="3">Unsure</mat-option>
              </mat-select>
            </div>
          </div>
        </div>
        <div style="display: flex; flex-direction: row;">
          <div class="form-container" style="width: 100%;">
            <label>Date Range</label>
              <div class="input-container">
                <mat-datepicker-toggle matSuffix [for]="rangePicker">
                  <mat-icon class="fa-duotone">calendar_days</mat-icon>
                </mat-datepicker-toggle>
                <div class="divider" style="height: 32px; border-top: 0;"></div>
                <mat-date-range-input [rangePicker]="rangePicker" style="margin-left:8px;">
                  <input matStartDate placeholder="Start date: MM/DD/YYYY" [(ngModel)]="selectedFact.dateStart" [ngModelOptions]="{standalone: true}">
                  <input matEndDate placeholder="End date: MM/DD/YYYY" [(ngModel)]="selectedFact.dateEnd" [ngModelOptions]="{standalone: true}">
                </mat-date-range-input>
              </div>
              <mat-date-range-picker #rangePicker></mat-date-range-picker>
          </div>
        </div>
        <div style="display: flex; flex-direction:column; margin-top:4px;">
          <div style="display: flex; flex-direction:row; justify-content: space-between;">
            <span class="area-header">Custodian</span>
            <div style="cursor: pointer;" (click)="showCustodianSelect=!showCustodianSelect" matTooltip="Click to toggle Add Custodians">
              <i class="fa-duotone fa-pen-to-square icon"></i>
            </div>
          </div>
          <div *ngIf="showCustodianSelect" style="margin-top:8px;">
            <div class="form-group">
              <div class="form-container" style="margin-right: 8px;">
                <label for="custodian-mat-select">Add Custodian To Fact</label>
                <mat-select matNativeControl style="height: 28px; border: 1px solid #565656;
                border-radius: 5px; display: flex; align-items: center; padding-left: 8px;"  (selectionChange)="appendCustodianToSelectedFact($event)" id="custodian-mat-select">
                  <mat-option *ngFor="let custodian of custodiansNotInFact" [value]="custodian">
                    {{custodian.name}}
                  </mat-option>
                </mat-select>
              </div>
            </div>
          </div>
          <div style="margin-top:12px;">
            <div style="width: 100%;">
              <div class="item-list">
                <div *ngFor="let custodian of selectedFact.linkedCustodians" class="item" (click)="detachCustodianFromSelectedFact(custodian)">
                  <div class="item-text">{{custodian.name}}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div style="display: flex; flex-direction: column; margin-top:4px;">
          <div style="display: flex; flex-direction:row; justify-content: space-between;">
            <span class="area-header">Linked Issues</span>
            <div style="cursor: pointer;" (click)="showIssuesSelect=!showIssuesSelect" matTooltip="Click to Add Issues">
              <i class="fa-duotone fa-pen-to-square icon"></i>
            </div>
          </div>
          <div *ngIf="showIssuesSelect" style="margin-top:8px;">
            <div class="form-group">
              <div class="form-container" style="margin-right: 8px;">
                <label for="issue-mat-select">Assign Fact To Issue</label>
                <mat-select matNativeControl style="height: 28px; border: 1px solid #565656;
                border-radius: 5px; display: flex; align-items: center; padding-left: 8px;" (selectionChange)="appendIssueToSelectedFact($event)" id="issue-mat-select">
                  <mat-option *ngFor="let issue of issuesNotInFact" [value]="issue">
                    {{issue.title}}
                  </mat-option>
                </mat-select>
              </div>
            </div>
          </div>
          <div style="margin-top:12px;">
            <div style="width: 100%;">
              <div class="item-list">
                <div *ngFor="let issue of selectedFact.linkedIssues" class="item" (click)="detachIssueFromSelectedFact(issue)">
                  <div class="item-text">{{issue.title}}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div style="display: flex; flex-direction: row; margin-top: 24px; gap:8px;">
          <lex-flat-button label="Save Fact" [icon]="'fa-duotone fa-check-double'" (clicked)="saveClicked()" style="width:100%;" [disabled]="editFactForm.invalid"></lex-flat-button>
          <lex-icon-button [icon]="'fa-duotone fa-xmark close-icon'" (click)="clearSelected()" matTooltip="Cancel"></lex-icon-button>
        </div>
      </div>

    </div>

  </div>

  <div action-footer *ngIf="!(selectedFact && selectedLinkedDocument)">
    <lex-flat-button *inRole="[roles.EditFeatureSet]" label="New Fact" [icon]="'fa-duotone fa-plus single-color-icon'" (clicked)="newFactClicked()"></lex-flat-button>
  </div>
</lex-action-panel>

